export default "__VITE_ASSET__BopG8trQ__"